var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLoadingBlue(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon_2",
    d: "M12 6C12 4.81331 11.6481 3.65327 10.9888 2.66658C10.3295 1.67988 9.39246 0.910849 8.2961 0.456723C7.19974 0.002597 5.99334 -0.116223 4.82946 0.115288C3.66557 0.3468 2.59647 0.918244 1.75736 1.75736C0.918244 2.59647 0.3468 3.66557 0.115288 4.82946C-0.116223 5.99334 0.00259702 7.19974 0.456723 8.2961C0.910849 9.39246 1.67988 10.3295 2.66658 10.9888C3.65327 11.6481 4.81331 12 6 12V10.6024C5.08973 10.6024 4.19991 10.3325 3.44305 9.82675C2.68619 9.32103 2.09629 8.60224 1.74794 7.76126C1.3996 6.92028 1.30846 5.99489 1.48604 5.10212C1.66363 4.20934 2.10196 3.38927 2.74562 2.74562C3.38927 2.10196 4.20934 1.66363 5.10212 1.48604C5.99489 1.30846 6.92028 1.3996 7.76126 1.74794C8.60224 2.09629 9.32103 2.68619 9.82675 3.44305C10.3325 4.19991 10.6024 5.08973 10.6024 6H12Z",
    fill: "#125BBE"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoadingBlue);
export default __webpack_public_path__ + "static/media/loading_blue.eb8dabd4.svg";
export { ForwardRef as ReactComponent };